var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDog208(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-2{fill:#f9f7e1;}.cls-2,.cls-3{stroke:#333;stroke-miterlimit:10;stroke-width:2px;}.cls-3{stroke-linecap:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dog_208"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_208",
    "data-name": 208,
    className: "cls-2",
    d: "M53.9,1.36c-13.61-.89-19,12-27.53,19.71C19.85,27,9.38,32.19,11,42.79c2,13.12,17.28,11.64,26.53,15.65,8.77,3.8,9,12.38,16.06,22,7.58,10.34,21.94,20.4,27.93,17.46C96.29,90.67,75.9,2.8,53.9,1.36Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "detail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "crevice",
    className: "cls-3",
    d: "M28.82,38.3a25,25,0,0,0,18-3.78A24.65,24.65,0,0,0,56.23,22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "crevice-2",
    "data-name": "crevice",
    className: "cls-3",
    d: "M51.65,30.62a49.6,49.6,0,0,0,4.58,29A48.46,48.46,0,0,0,68.8,75.37"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog208);
export default __webpack_public_path__ + "static/media/dog_208.e836a37dcf026f26c365146346798ad9.svg";
export { ForwardRef as ReactComponent };